// extracted by mini-css-extract-plugin
export default {"wrapper":"_0-z","play":"a1-z"};